export const newsletterPopupCookieKey = 'NewsletterPopupShow';
export const newsletterPopupCookieValue = 'Done';

export const newsletterSubscribeCookieKey = 'NewsletterSubscribe';
export const newsletterSubscribeCookieValue = 'Done';
